import { Link, useNavigate, useSearchParams } from "react-router-dom";
import React, { useState, useContext, useEffect } from 'react';
import "../../assets/css/--component-login.css"
import logoFromBG from "../../assets/images/auth-bg.png";
import { postLogin, getTimezoneOffset } from "../../helper/backend-methods";
import T, { _T } from "../../locale/translations-main";
import { Input } from "reactstrap";
import { startConnection } from "../../helper/signalr-service";
import { UserContext } from "../../context/userContext";

function SignIn(props) {
    const [search, setSearch] = useSearchParams();
    const [redirect, setRedirect] = useState(false);
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState({ commonField: "", phoneField: "", otpField: new Array(4).fill(""), passwordField: "", confirmPasswordField: "", showPasswordField: false, showConfirmPasswordField: false, login: false, enableOTP: false, enablePassword: false, enableConfirmPassword: false, locked: false })
    const history = useNavigate();
    const [errors, setErrors] = useState({ commonField: "", phoneField: "", otpField: "", passwordField: "", confirmPasswordField: "", serverError: "" })
    const { setUser } = useContext(UserContext);


    const emailRegexSafe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,10}$/;

    const validateEmail = (email) => {
        if (!email) return "This field is required";

        const trimmed = email.replace(/\s+/g, "");

        if (/^\d+$/.test(trimmed)) {
            if (trimmed.length !== 12 || !trimmed.startsWith("9665")) {
                return "Please provide a valid phone number";
            }
            return "";
        }

        if (!emailRegexSafe.test(trimmed)) {
            return "Please provide a valid email address";
        }

        return "";
    };

    useEffect(()=>{
        if (search) {
            if (search.get('redirect') && search.get('redirect') !== "") {
                setRedirect(search.get('redirect'))
            }
        }
    },[])

    
    const validateForm = (values) => {
        const errors = {};
        errors.commonField = validateEmail(values.commonField);
        errors.passwordField = !values.passwordField || values.passwordField.length < 6
            ? "Password is required"
            : "";
        return errors;
    };
    
    const tryLogin = async () => {
        if (loading) return;
    
        const errorsObj = validateForm(values);
        setErrors(errorsObj);
    
        if (Object.values(errorsObj).some(err => err)) return;
    
        setLoading(true);
        try {
            const { data } = await postLogin({
                Email: values.commonField,
                Password: values.passwordField,
                Timezone: getTimezoneOffset()
            });
    
            if (!data.Status) {
                setErrors(prev => ({ ...prev, serverError: "Your email or password is incorrect." }));
                return;
            }
    
            localStorage.setItem("authToken", data.Data.Token.Access_Token);
            localStorage.setItem("userinfo", JSON.stringify(data.Data.UserInfo));
            setUser(data.Data.UserInfo);
            startConnection();
            history(redirect || "/account/dashboard");
    
        } catch (err) {
            setErrors(prev => ({ ...prev, serverError: "Your email or password is incorrect." }));
        } finally {
            setLoading(false);
        }
    };
    
    return (

        <section id="login">
            <div className="wrapper" style={{ "width": "100%" }}>
                <div className="login-form-wrapper">
                    <div className="login-background"><img src={logoFromBG} alt="" /></div>
                    {
                        <form noValidate>
                            <h1 className="form-title">Welcome to Main's</h1>
                            <p className="form-description">Please enter your credentials to login.</p>
                            {errors.serverError ? <p className="text-left txt-danger fs-16 fw-400"><i className="ri-error-warning-line"></i> {errors.serverError}</p> : null}
                            <div className="form-group has-icon">
                                <label htmlFor="commonField">Email Address<span className="txt-danger">*</span></label>
                                <input id="commonField" type="text" name="commonField" onChange={(e) => { setValues((prev) => ({ ...prev, commonField: e.target.value.replace(/\s+/g, '').slice(0, 50) })) }} value={values.commonField} placeholder="Email Addess Here" className={`${errors.commonField || errors.serverError ? "bd-danger" : ""}`} />
                                {errors.commonField || errors.serverError ? <button type="button"><i className="ri-error-warning-line txt-danger"></i></button> : null}
                                {errors.commonField ? <span className="txt-danger fs-12 fw-400">{errors.commonField}</span> : null}
                            </div>
                            <div className="form-group has-icon">
                                <label htmlFor="passwordField">Password<span className="txt-danger">*</span></label>
                                <input id="passwordField" type={values.showPasswordField ? "text" : "password"} name="passwordField" onChange={(e) => { setValues((prev) => ({ ...prev, passwordField: e.target.value.replace(/\s+/g, '').slice(0, 30) })) }} value={values.passwordField} placeholder="Your Password Here" className={`${errors.passwordField || errors.serverError ? "bd-danger" : ""}`} />
                                <button onClick={() => { setValues((prev) => ({ ...prev, showPasswordField: !prev.showPasswordField })) }} type="button" >{values.showPasswordField ? <i className="ri-eye-off-line"></i> : <i className="ri-eye-line"></i>}</button>
                                {errors.passwordField ? <span className="txt-danger fs-12 fw-400">{errors.passwordField}</span> : null}
                            </div>
                            <div className="form-additional d-flex align-items-center justify-content-between mb-3">
                                <div className="">
                                    <Input type="checkbox" name="remember" className="form-check-input" id="remember" value={"true"} />
                                    <label htmlFor="remember" className="fs-14 fw-400 text-gray mb-0 ms-2">Remember me</label>
                                </div>
                                <div className="text-right">
                                    <Link to={"/forgot-password"} className="link fs-14"><span className="link-text">Forgot Password?</span></Link>
                                </div>
                            </div>
                            <div className="form-group">
                                <button type="button" onClick={tryLogin} disabled={loading} className={`btn btn-primary w-100 rounded-5 border-0 ${loading ? "btn-disabled" : ""}`}>{loading ? "Please Wait..." : "LOGIN"}</button>
                            </div>
                            <span className="separator mt-5 mb-4"></span>
                            {
                                !loading ?
                                    <div className="form-group mb-0 fs-14 text-gray text-left">
                                        Do not have an account?
                                        <Link to={"/register"} className="link fs-14 ml-2">&nbsp; Register Now</Link>
                                    </div> : null
                            }
                        </form>
                    }
                </div>
            </div>
        </section>
    )

}
export default SignIn;